import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

const LINKS = [
  { label: "HOME", path: "/", testid: "nav-link-home" },
  { label: "THE ROYAL VAULT", path: "/vault", testid: "nav-link-vault" },
  { label: "OFFICIAL MUSIC", path: "/official-music", testid: "nav-link-official" },
  { label: "ABOUT", path: "/about", testid: "nav-link-about" },
  { label: "JOIN THE ROYAL LIST", path: "/royal-list", testid: "nav-link-royal-list" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <header data-testid="main-navbar" className="fixed top-0 inset-x-0 z-50 bg-obsidian/80 backdrop-blur-md border-b border-gold/15">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 h-16 sm:h-20 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="font-serif text-lg sm:text-xl tracking-[0.2em] text-cream hover:text-gold transition-colors duration-300">
          QUEEN DENAE
        </Link>
        <nav className="hidden lg:flex items-center gap-8">
          {LINKS.map((l) => (
            <NavLink
              key={l.path}
              to={l.path}
              data-testid={l.testid}
              className={({ isActive }) =>
                `font-mono text-[11px] tracking-[0.25em] transition-colors duration-300 ${
                  isActive ? "text-gold" : "text-sand hover:text-cream"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>
        <button
          data-testid="mobile-menu-btn"
          onClick={() => setOpen(!open)}
          className="lg:hidden text-cream p-2"
          aria-label="Toggle menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
      <AnimatePresence>
        {open && (
          <motion.nav
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.35, ease: "easeOut" }}
            className="lg:hidden overflow-hidden bg-obsidian/95 backdrop-blur-md border-b border-gold/15"
          >
            <div className="px-6 py-8 flex flex-col gap-6">
              {LINKS.map((l, i) => (
                <motion.div
                  key={l.path}
                  initial={{ opacity: 0, x: -16 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: i * 0.06 }}
                >
                  <NavLink
                    to={l.path}
                    data-testid={`mobile-${l.testid}`}
                    onClick={() => setOpen(false)}
                    className={({ isActive }) =>
                      `font-serif text-2xl tracking-wide ${isActive || location.pathname === l.path ? "text-gold" : "text-cream"}`
                    }
                  >
                    {l.label}
                  </NavLink>
                </motion.div>
              ))}
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
};
